import {Box, BoxProps, Text, VStack} from '@chakra-ui/react';
import {ComponentType} from 'react';
import {Link} from 'react-router-dom';

//Boutons générique principalement utilisé dans la BottomNav
export const NavButton: React.FC<
  {
    showAs?: ComponentType;
    ButtonIcon: ComponentType<{
      height?: string | undefined;
      color?: string | undefined;
    }>;
    label: string;
    to?: string;
    onClick?: () => void;
    color?: string;
    textColor?: string;
  } & Omit<BoxProps, 'color'>
> = ({
  showAs = Link,
  ButtonIcon,
  label,
  color = 'blue.main',
  textColor = 'blue.text',
  onClick,
  ...props
}) => {
  return (
    <Box
      as={showAs}
      height='100%'
      borderRadius='md'
      cursor='pointer'
      flex='1'
      _hover={{bg: 'gray.bg'}}
      p='1'
      transition='all 0.2s ease'
      onClick={onClick}
      {...props}
    >
      <VStack
        gap='0'
        justify='center'
        height='100%'
      >
        <Box
          display='flex'
          height='25px'
          alignItems='center'
        >
          <ButtonIcon
            height='25px'
            color={color}
          />
        </Box>
        <Text
          fontSize='sm'
          textAlign='center'
          fontWeight='500'
          whiteSpace='nowrap'
          color={textColor}
        >
          {label}
        </Text>
      </VStack>
    </Box>
  );
};
